import { cn } from '@util/index';
import Link from 'next/link';

const PageSectionHeader = ({
  title,
  linkText,
  href,
  target,
  variant = 'default',
  titleClassName,
  subtitle,
  subtitleClassName,
  linkClassName,
  seeAllPosition: _seeAllPosition = 'subtitle',
}: {
  title: string;
  href?: string;
  target?: string;
  linkText?: string;
  variant?: 'default' | 'secondary' | 'centered';
  titleClassName?: string;
  subtitle?: string;
  subtitleClassName?: string;
  seeAllPosition?: 'subtitle' | 'title';
  linkClassName?: string;
}) => {
  return variant === 'default' ? (
    <div
      className={`flex ${
        linkText ? 'w-full' : 'w-fit'
      } flex-wrap items-center justify-between px-8 sm:px-0`}
    >
      <div className="flex w-full flex-col items-start gap-2 sm:w-auto sm:flex-row sm:items-center sm:gap-6">
        <div className="flex w-full items-center justify-between gap-2 sm:gap-6">
          <h2
            className={cn(
              'flex-nowrap whitespace-nowrap text-[2.4rem] font-semibold text-inherit sm:text-[3rem]',
              titleClassName
            )}
          >
            {title}
          </h2>

          {linkText && href && (
            <Link
              href={href}
              target={target ?? '_self'}
              className={cn(
                'transition-color text-[2rem] font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:hidden',
                linkClassName
              )}
            >
              {linkText}
            </Link>
          )}
        </div>

        {!!subtitle && (
          <>
            <div className="hidden h-[3rem] w-px bg-brand-light-gray sm:block" />
            <span
              className={cn(
                'hidden w-full whitespace-nowrap text-[2.1rem] font-medium text-zinc-600 sm:flex',
                subtitleClassName
              )}
            >
              {subtitle}
            </span>
          </>
        )}

        {!!subtitle && (
          <div className="flex w-full items-center justify-between sm:hidden">
            <span
              className={cn(
                'text-[2.1rem] font-medium text-zinc-400 sm:text-zinc-600',
                subtitleClassName
              )}
            >
              {subtitle}
            </span>
          </div>
        )}
      </div>

      {linkText && href && (
        <Link
          href={href}
          target={target ?? '_self'}
          className={cn(
            'transition-color hidden text-[2rem] font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:inline',
            linkClassName
          )}
        >
          {linkText}
        </Link>
      )}
    </div>
  ) : variant === 'secondary' ? (
    <div className="mb-[2.4rem] flex w-full items-center justify-between sm:mb-[4rem]">
      <div className="flex w-full items-center justify-between gap-2 sm:w-auto sm:justify-start">
        <h2 className="mb-[1.6rem] block w-fit text-center text-[2.4rem] font-semibold sm:m-0 sm:inline-block sm:text-[3.2rem]">
          {title}
        </h2>
        {linkText !== '' && href !== '' && (
          <Link
            href={href ?? ''}
            className={cn(
              'transition-color mb-[1.6rem] block text-[2rem] font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:hidden',
              linkClassName
            )}
          >
            {linkText}
          </Link>
        )}
      </div>
      {linkText !== '' && href !== '' && (
        <Link
          href={href ?? ''}
          className={cn(
            'transition-color hidden font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:inline',
            linkClassName
          )}
        >
          {linkText}
        </Link>
      )}
    </div>
  ) : (
    <div className="flex w-full items-start justify-center px-8 sm:mx-auto sm:max-w-content sm:justify-between">
      <div className="flex w-full flex-col items-center gap-y-8 sm:w-auto sm:flex-row sm:items-center sm:gap-y-0">
        <h2 className="mb-[1.6rem] block w-fit text-center text-[2.4rem] font-semibold sm:m-0 sm:inline-block sm:text-[3.2rem]">
          {title}
        </h2>
        {linkText && href && (
          <Link
            href={href}
            className={cn(
              'transition-color mb-[1.6rem] block text-[2rem] font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:hidden',
              linkClassName
            )}
          >
            {linkText}
          </Link>
        )}
      </div>
      {linkText && href && (
        <Link
          href={href}
          className={cn(
            'transition-color hidden text-[2rem] font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:inline',
            linkClassName
          )}
        >
          {linkText}
        </Link>
      )}
    </div>
  );
};

export default PageSectionHeader;
